/*****************************************************************************
 * REVISION 1.0
 * Fecha: 01/09/2024
 *
 * @description JS para manejo de labels
 * @author lferrer
 * @version 1.0
 *
 ****************************************************************************/
export const properties = {
  /** General */

  /** footer */
  com_sinpepay_label_footer_terms_conditions: "Términos y Condiciones",
  /** Page not found */
  com_sinpepay_label_page_404_title: "Oops!",
  com_sinpepay_label_page_404_subtitle: "Página no encontrada",

  /** Loading */
  com_sinpepay_label_loading_title: "Cargando",

  /** Home */
  com_sinpepay_label_home_title: "SimplePay",

  /** General label */
  com_sinpepay_label_yes: "Si",
  com_sinpepay_label_not: "No",
  com_sinpepay_label_add_subtitle: "Ingrese los datos indicados",
  com_sinpepay_label_update_subtitle: "Modifique los datos indicados",
  com_sinpepay_label_code: "Código",
  com_sinpepay_label_codetfa: "Código de validación",
  com_sinpepay_label_phone: "Teléfono",
  com_sinpepay_label_url: "Url",
  com_sinpepay_label_category: "Categoría",
  com_sinpepay_label_description: "Descripción",
  com_sinpepay_label_timesession: "Tiempo sesión (seg)",
  com_sinpepay_label_name: "Nombre",
  com_sinpepay_label_lastname: "Apellido",
  com_sinpepay_label_secondlastname: "Segundo apellido",
  com_sinpepay_label_onelastname: "Apellido 1",
  com_sinpepay_label_twolastname: "Apellido 2",
  com_sinpepay_label_indSendSms: "¿Enviar código de acceso por SMS?",
  com_sinpepay_label_state: "Estado",
  com_sinpepay_label_coderejection: "Código de rechazo",
  com_sinpepay_label_descriptionrejection: "descripción de rechazo",
  com_sinpepay_label_clientcode: "Código de cliente",
  com_sinpepay_label_role: "Perfil",
  com_sinpepay_label_createat: "Fecha de creación",
  com_sinpepay_label_createat2: "Fecha solicitud",
  com_sinpepay_label_createat3: "Fecha",
  com_sinpepay_label_orgcode: "Código de organización",
  com_sinpepay_label_email: "Correo electrónico",
  com_sinpepay_label_user: "Usuario",
  com_sinpepay_label_user_ldap: "Usuario de red",
  com_sinpepay_label_old_password: "Contraseña actual",
  com_sinpepay_label_password: "Contraseña",
  com_sinpepay_label_passwordrepeat: "Repita contraseña",
  com_sinpepay_label_authcode: "Código de acceso",
  com_sinpepay_label_authcode_ph: "Código de 6 dígitos",
  com_sinpepay_label_sinpereference: "Referencia SINPE",
  com_sinpepay_label_sinpereferPlaceHolder: "25 dígitos o últimos 7",
  com_sinpepay_label_identificationOrigin: "Identificación origen",
  com_sinpepay_label_bac_sinpereference: "Referencia BAC",
  com_sinpepay_label_amount_commission: "Monto comisión",
  com_sinpepay_label_amount_vat: "Monto IVA",
  com_sinpepay_label_totals: "Totales",
  com_sinpepay_label_grandtotal: "Total General",
  com_sinpepay_label_amount: "Monto Pagado",
  com_sinpepay_label_origin_phone: "Teléfono origen",
  com_sinpepay_label_destination_phone: "Teléfono destino",
  com_sinpepay_label_data: "Datos",
  com_sinpepay_label_organization: "Organización",
  com_sinpepay_label_identification: "Identificación",
  com_sinpepay_label_fullname: "Nombre completo",
  com_sinpepay_label_tradename: "Nombre comercial",
  com_sinpepay_label_phone_number: "Número de teléfono",
  com_sinpepay_label_account_number: "Número de cuenta",
  com_sinpepay_label_provider: "Proveedor",
  com_sinpepay_label_main_indicator: "Telefono principal",
  com_sinpepay_label_servicecode: "Tipo de servicio",
  com_sinpepay_label_startdate: "Fecha desde",
  com_sinpepay_label_enddate: "Fecha hasta",
  com_sinpepay_label_system: "Sistema",
  com_sinpepay_label_device: "Dispositivo",
  com_sinpepay_label_users: "Usuario",
  com_sinpepay_label_idtransaction: "Id Transacción",
  com_sinpepay_label_clientphone: "Tel. Cliente",
  com_sinpepay_label_orgPhone: "Tel. Destino",
  com_sinpepay_label_errcode: "Código de error sinpe",
  com_sinpepay_label_transaction: "ID. Transacción",
  com_sinpepay_label_preregister: "ID. Preregistro",
  com_sinpepay_label_client_transaction: "ID. Transacción cliente",
  com_sinpepay_label_parameter_type: "Tipo Parametro",
  com_sinpepay_label_value: "Valor",
  com_sinpepay_label_affiliate: "Afiliado",
  com_sinpepay_label_terminals: "Terminales",
  com_sinpepay_label_number: "Número",
  com_sinpepay_label_plan: "Plan",
  com_sinpepay_label_segment: "Segmento",
  com_sinpepay_label_preregister_amount: "Monto Original",
  com_sinpepay_label_preregister_extended: "Extendido",
  com_sinpepay_label_date_sort: "Ordenar por",
  com_sinpepay_label_date_sort_asc: "Del más reciente al más antiguo",
  com_sinpepay_label_date_sort_desc: "Del más antiguo al más reciente",
  /** General error labels in forms */
  com_sinpepay_label_field_required: "Campo requerido",
  com_sinpepay_label_field_format: "Formato invalido",
  com_sinpepay_label_field_select: "Debe seleccionar un registro",
  com_sinpepay_label_field_maxlenght: (lenght) =>
    `Longitud máxima permitida (${lenght})`,
  com_sinpepay_label_field_minlenght: (lenght) =>
    `Longitud mínima permitida (${lenght})`,
  com_sinpepay_label_field_required_especial_symbol: "Al menos un carácter con símbolos especiales",
  com_sinpepay_label_field_requered_uppercase: "Al menos una letra mayúscula",
  com_sinpepay_label_field_requered_lowercase: "Al menos una letra minúscula ",
  com_sinpepay_label_field_requered_numeric: "Al menos un número del 0 al 9",
  /** General sucess labels in process */
  com_sinpepay_label_request_save: "Registro insertado con exito",
  com_sinpepay_label_request_update: "Registro actualizado con exito",
  com_sinpepay_label_request_active: "Registro activado con exito",
  com_sinpepay_label_request_inactive: "Registro inactivado con exito",
  /** General error labels in process */
  com_sinpepay_label_request_connection: "Falla en solicitud al servidor",
  com_sinpepay_label_request_unauthorized: "No tiene permiso para realizar esta acción",
  com_sinpepay_label_request_badrequest: "Falla en parametros dentro de la solicitud al servidor",

  /** General button labels */
  com_sinpepay_label_button_accept_title: "Aceptar",
  com_sinpepay_label_button_ok_title: "Ok",
  com_sinpepay_label_button_cancel_title: "Cancelar",
  com_sinpepay_label_button_save_title: "Registrar",
  com_sinpepay_label_button_save2_title: "Guardar",
  com_sinpepay_label_button_update_title: "Editar",
  com_sinpepay_label_button_detail_title: "Ver detalle",
  com_sinpepay_label_button_changestate_title: "Cambiar estado",
  com_sinpepay_label_button_active_title: "Activar",
  com_sinpepay_label_button_inactivate_tittle: "Inactivar",
  com_sinpepay_label_button_password_tittle: "Generar Contraseña de Sistema",
  com_sinpepay_label_button_back_title: "Atras",
  com_sinpepay_label_button_back2_title: "Volver",
  com_sinpepay_label_button_add_title: "Agregar",
  com_sinpepay_label_button_search_title: "Buscar",
  com_sinpepay_label_button_clear_title: "Limpiar",
  com_sinpepay_label_button_login_title: "Ingresar",
  com_sinpepay_label_button_close_title: "Cerrar",
  com_sinpepay_label_button_view_title: "Ver",
  com_sinpepay_label_button_xlxs_title: "Excel",
  com_sinpepay_label_button_csv_title: "csv",
  com_sinpepay_label_button_exit_title: "Salir",
  com_sinpepay_label_button_forgotpass_title: "Recuperar contraseña",
  com_sinpepay_label_button_generatepass_title: "Generar contraseña",
  com_sinpepay_label_button_continue_title: "Continuar",
  com_sinpepay_label_select_title: "Seleccionar",
  com_sinpepay_label_select_all_title: "Todos",
  com_sinpepay_label_password_recovery: "Recuperar",
  com_sinpepay_label_button_createuniquecode_title: "Crear código único",
  com_sinpepay_label_button_create_title: "Crear",
  com_sinpepay_label_button_add_segment_title: "Agregar segmento",
  /** General state labels */
  com_sinpepay_label_active_desc: "Activo",
  com_sinpepay_label_inactivate_desc: "Inactivo",
  com_sinpepay_label_ing_desc: "Ingresado",
  com_sinpepay_label_conciliation_desc: "Por conciliar",
  com_sinpepay_label_pay_desc: "Pagado",
  com_sinpepay_label_err_desc: "Error",
  com_sinpepay_label_unknown_desc: "Desconocido",
  com_sinpepay_label_unknown2_desc: "No registrado",
  com_sinpepay_label_prc_desc: "Procesando",
  com_sinpepay_label_rec_desc: "Rechazado",
  com_sinpepay_label_vrf_desc: "Verificado",
  com_sinpepay_label_blo_desc: "Bloqueado",

  /** Sesion */
  com_sinpepay_label_sesion_modal_title: "Sesión",
  com_sinpepay_label_sesion_question: "¿Desea continuar la sesión?",

  /** Menu dashboard label */
  com_sinpepay_label_dashboard_menu_logout: "Cerrar sesión",
  com_sinpepay_label_dashboard_menu_login: "Iniciar sesión",
  /** Search admin menu */
  com_sinpepay_label_dashboard_menu_search_sinpe: "Consulta Sinpe Móvil",
  /** Report admin menu */
  com_sinpepay_label_dashboard_menu_search: "Consulta",
  com_sinpepay_label_dashboard_menu_search_transaction: "Transacciones",
  com_sinpepay_label_dashboard_menu_search_commissionsvat: "Comisiones e iva",
  com_sinpepay_label_dashboard_menu_search_preregister: "Preregistros",


  /** Maintenance maintenance menu */
  com_sinpepay_label_dashboard_menu_maintenance: "Mantenimiento",
  com_sinpepay_label_dashboard_menu_maintenance_servicetype: "Tipo de servicios",
  com_sinpepay_label_dashboard_menu_maintenance_system: "Sistemas",
  com_sinpepay_label_dashboard_menu_maintenance_device: "Dispositivos",
  com_sinpepay_label_dashboard_menu_maintenance_phone: "Telefonos",
  com_sinpepay_label_dashboard_menu_maintenance_phoneservice: "Telefonos por servicio",
  com_sinpepay_label_dashboard_menu_maintenance_affiliate: "Afiliados",
  com_sinpepay_label_dashboard_menu_maintenance_terminal: "Terminales",
  com_sinpepay_label_dashboard_menu_maintenance_plan: "Planes",
  com_sinpepay_label_dashboard_menu_maintenance_userdevice: "Usuarios por dispositivo",
  com_sinpepay_label_dashboard_menu_maintenance_preauthorizedAmounts: "Montos Pre.Autorizados",

  /** Management management menu */
  com_sinpepay_label_dashboard_menu_management: "Gestión",
  com_sinpepay_label_dashboard_menu_management_organization: "Organizaciones",
  com_sinpepay_label_dashboard_menu_management_segment: "Segmentos Cliente",
  com_sinpepay_label_dashboard_menu_management_organizationconfig: "Configuracion de la organizaciones",
  com_sinpepay_label_dashboard_menu_management_configuration: "Configuración",

  /** Security security menu */
  com_sinpepay_label_dashboard_menu_security: "Seguridad",
  com_sinpepay_label_dashboard_menu_security_user: "Usuarios",
  com_sinpepay_label_dashboard_menu_security_group: "Grupos",
  com_sinpepay_label_dashboard_menu_security_option: "Opciones",

  /** Table label */
  com_sinpepay_label_table_filter_title: "Filtrar",
  com_sinpepay_label_table_filter_title2: "Filtrar por:",
  com_sinpepay_label_table_filter_title3: "Filtro de búsqueda",
  com_sinpepay_label_table_action: "Acciones",
  com_sinpepay_label_table_unique_action: "Acción",
  com_sinpepay_label_table_empty: "No existen registros",
  com_sinpepay_label_table_download: "Descargar ",

  /** General modal label  */
  com_sinpepay_label_modal_active_title: "Activar registro",
  com_sinpepay_label_modal_inactive_title: "Inactivar registro",

  /** login */
  com_sinpepay_label_login_title: "Portal Empresarial",
  com_sinpepay_label_login_forget_password_title: "¿Olvidaste tu contraseña?",
  /** login info*/
  com_sinpepay_label_login_authcode_info: "Se ha enviado a su correo un código único de acceso",
  com_sinpepay_label_login_authcode_sms_info: "Se ha enviado a su teléfono (SMS) un código único de acceso",
  /** login error*/
  com_sinpepay_label_login_error: "Correo o contraseña inválida",
  com_sinpepay_label_login_error2:
    "Usuario no tiene permiso de loguearse en este sitio",
  com_sinpepay_label_login_error3:
    "El usuario no está activo",
  com_sinpepay_label_login_general_error:
    "El código de la organización, usuario o contraseña son inválidos. Por favor, verifique los datos e intente nuevamente",
  com_sinpepay_label_login_general_error2:
    "El código de acceso es inválido. Por favor, verifique los datos e intente nuevamente",
  com_sinpepay_label_login_general_error3:
    "Ha superado el máximo de intentos permitidos, espere e intente mas tarde.",
  com_sinpepay_label_logout:
    "La sesión ha caducado",
  com_sinpepay_label_login_refresh_general_error:
    "Error en proceso de refrescar sesión en el portal empresarial",
  com_sinpepay_label_login_logout_error: "Error en proceso de cerrar sesión",
  com_sinpepay_label_captcha: "Ha superado el maximo de intentos, favor volver a iniciar sesion",
  com_sinpepay_label_captcha_timeout: "Ha superado el maximo de tiempo, favor volver a iniciar sesion",

  /** search sinpe */
  com_sinpepay_label_search_sinpe_error: "Error en consulta de transacción por referencia sinpe",

  /** user */
  com_sinpepay_label_security_user_add_title: "Agregar usuario",
  com_sinpepay_label_security_user_update_title: "Editar usuario",
  com_sinpepay_label_security_user_update_pass_title: "Editar contraseña de usuario",
  com_sinpepay_label_button_usergroup_title: "Grupos por usuario",

  com_sinpepay_label_security_user_find_error: "Error en consulta de usuarios",
  com_sinpepay_label_security_user_findid_error: "Error en consulta por id del usuario",
  com_sinpepay_label_security_user_save_error: "Error en proceso de guardar usuario",
  com_sinpepay_label_security_user_update_error: "Error en proceso de actualizar usuario",
  com_sinpepay_label_security_user_password_error: "Error en proceso de actualizar la contraseña",
  com_sinpepay_label_security_user_inactive_error: "Error en proceso de inactivar usuario",
  com_sinpepay_label_security_user_active_error: "Error en proceso de activar usuario",

  com_sinpepay_label_security_user_generate_pass_tittle: "Generar contraseña temporal",
  com_sinpepay_label_modal_user_generate_pass_body: (username) => `¿Está seguro de generar la contraseña al usuario ${username} ?`,
  com_sinpepay_label_security_user_generate_pass_error: "Error en proceso de generación de la contraseña",
  com_sinpepay_label_request_generate_pass: "Se generó la contraseña de forma exitosa y se ha enviado a su dirección de correo electrónico asociado a su usuario",


  /** group */
  com_sinpepay_label_security_group_add_title: "Agregar grupo",
  com_sinpepay_label_security_group_update_title: "Editar grupo",
  com_sinpepay_label_button_groupoption_title: "Opciones por grupo",

  com_sinpepay_label_security_group_find_error: "Error en consulta de grupos",
  com_sinpepay_label_security_group_find2_error: "Error en consulta de grupos asociado al usuario",
  com_sinpepay_label_security_group_findid_error: "Error en consulta por id del grupo",
  com_sinpepay_label_security_group_save_error: "Error en proceso de guardar grupo",
  com_sinpepay_label_security_group_update_error: "Error en proceso de actualizar grupo",
  com_sinpepay_label_security_group_inactive_error: "Error en proceso de inactivar grupo",
  com_sinpepay_label_security_group_active_error: "Error en proceso de activar grupo",
  com_sinpepay_label_security_group_isAdmin: "¿Grupo administrador?",

  /** option */
  com_sinpepay_label_security_option_add_title: "Agregar opción",
  com_sinpepay_label_security_option_update_title: "Editar opción",
  com_sinpepay_label_security_option_rootmenu_title: "Menú interno",
  com_sinpepay_label_security_option_rootmenu_title2: "Interno",
  com_sinpepay_label_security_option_find_error: "Error en consulta de opciones",
  com_sinpepay_label_security_option_findid_error: "Error en consulta por id del opción",
  com_sinpepay_label_security_option_save_error: "Error en proceso de guardar opción",
  com_sinpepay_label_security_option_update_error: "Error en proceso de actualizar opción",
  com_sinpepay_label_security_option_inactive_error: "Error en proceso de inactivar opción",
  com_sinpepay_label_security_option_active_error: "Error en proceso de activar opción",

  /** profile */
  com_sinpepay_label_profile_data_title: "Datos del Usuario",
  com_sinpepay_label_profile_password_title: "Actualizar contraseña",
  com_sinpepay_label_profile_password_different_error: "Las contraseñas no coinciden",
  com_sinpepay_label_psw_change_swal_title: "Cambio de contraseña exitoso",
  com_sinpepay_label_psw_change_title: "Contraseña vencida",
  com_sinpepay_label_psw_change_desc: "Contraseña vencida, por favor proceder a realizar el cambio de contraseña",
  com_sinpepay_label_profile_password_info: (num) => `La nueva contraseña debe ser diferente a las últimas ${num} anteriores`,

  /** Organization */
  com_sinpepay_label_organization_add_title: "Agregar organización",
  com_sinpepay_label_organization_update_title: "Editar organización",
  com_sinpepay_label_organization_orgcode: "Código de organización",
  com_sinpepay_label_organization_plan: "Plan",
  com_sinpepay_label_organization_menu_config: "Configuración",
  com_sinpepay_label_organization_menu_system: "Sistemas",
  com_sinpepay_label_organization_menu_phone: "Telefonos",
  com_sinpepay_label_organization_menu_servicetype: "Tipos de servicios",
  com_sinpepay_label_organization_menu_phoneservicetype: "Telefonos por servicio",
  com_sinpepay_label_organization_add_segment_tittle: "Agregar segmento",
  com_sinpepay_label_request_organization_add_segment: "Se guardo el segmento de forma exitosa",

  /** Organization service error label */
  com_sinpepay_label_organization_find_error: "Error en consulta de organizaciones",
  com_sinpepay_label_organization_findid_error: "Error en consulta por id de organización",
  com_sinpepay_label_organization_save_error: "Error en proceso de guardar organización",
  com_sinpepay_label_organization_update_error: "Error en proceso de actualizar organización",
  com_sinpepay_label_organization_inactive_error: "Error en proceso de inactivar organización",
  com_sinpepay_label_organization_active_error: "Error en proceso de activar organización",
  com_sinpepay_label_organization_add_segment_error: "Error en proceso guardar el segmento",



  com_sinpepay_label_organizationconfig_applyconciliation: "Activar conciliación",
  com_sinpepay_label_organizationconfig_conciliationurl: "Url conciliación",
  com_sinpepay_label_organizationconfig_automaticverification: "Verificación automática",
  com_sinpepay_label_organizationconfig_otpgenerateindicator: "Activar OTP",
  com_sinpepay_label_organizationconfig_authenticatiotype: "Tipo autenticación",
  com_sinpepay_label_organizationconfig_authenticationurl: "Url autenticación",
  com_sinpepay_label_organizationconfig_authenticationrespkey: "Llave de respuesta autenticación (JSON)",
  com_sinpepay_label_organizationconfig_transactionMaxAmount: "Monto Máximo Transaccional",
  com_sinpepay_label_organizationconfig_minimumBilling: "Monto mínimo de facturación",
  com_sinpepay_label_organizationconfig_roundingindicator: "Activar Redondeo",
  com_sinpepay_label_rounding_modal_title_yes: "Activar redondeo",
  com_sinpepay_label_rounding_modal_title_no: "Desactivar redondeo",
  com_sinpepay_label_rounding_modal_body_yes: "Al habilitar esta opción permitirá aceptar pagos por SINPE Móvil ajustados al colón más cercano (superior o inferior), por lo que el monto podría no coincidir exactamente con el valor de la factura. ¡Esta seguro que desea habilitarlo?",
  com_sinpepay_label_rounding_modal_body_no: "Si deshabilita esta opción los pagos vía SINPE Móvil deberán coincidir exactamente con el monto facturado (incluidos decimales). Confirme que el cliente pueda cumplir esta condición. ¿Esta seguro que desea deshabilitarla?",
  com_sinpepay_label_organizationconfig_extendedPreregister: "Tipo de Pre-Registro",
  com_sinpepay_label_organizationconfig_extendedPreregisterImmediate: "Inmediato",
    com_sinpepay_label_organizationconfig_extendedPreregister24H: "24 Horas",

  /** organization config service error label */
  com_sinpepay_label_organizationconfig_findid_error: "No existe la configuración de la organizacion",
  com_sinpepay_label_organizationconfig_save_error: "Error en proceso de guardar configuración de la organización",
  com_sinpepay_label_organizationconfig_update_error: "Error en proceso de actualizar configuración de la organización",

  /** system */
  com_sinpepay_label_system_add_title: "Agregar sistema",
  com_sinpepay_label_system_update_title: "Editar sistema",
  com_sinpepay_label_system_password_title: "Generar nueva contraseña de sistema",
  com_sinpepay_label_system_password: "¿Desea enviar una nueva contraseña de sistema? Esto invalidará la contraseña anterior.",
  com_sinpepay_label_system_password_send: "Se envió la nueva contraseña al correo",

  com_sinpepay_label_system_find_error: "Error en consulta de sistemas por organización",
  com_sinpepay_label_system_findid_error: "Error en consulta por id del sistema",
  com_sinpepay_label_system_save_error: "Error en proceso de guardar sistema",
  com_sinpepay_label_system_update_error: "Error en proceso de actualizar sistema",
  com_sinpepay_label_system_inactive_error: "Error en proceso de inactivar sistema",
  com_sinpepay_label_system_active_error: "Error en proceso de activar sistema",
  com_sinpepay_label_system_password_error: "Error en proceso de generar contraseña",

  /** system credentials */
  com_sinpepay_label_system_generate_credencials_title: "¿Está seguro de generar nuevas credenciales de conexión?",
  com_sinpepay_label_system_generate_credencials: (systemName) => `Al generar nuevas credenciales, las anteriores serán revocadas. Se debe actualizar las credenciales en los sistemas conectados lo antes posible para restablecer la conexión. ¿Desea continuar y generar nuevas credenciales para el sistema ${systemName}?`,
  com_sinpepay_label_system_generate_credencials_send: (systemName) => `Las nuevas credenciales del sistema ${systemName} fueron enviadas al correo electrónico asociado a la organización.`,
  com_sinpepay_label_system_credencials_error: "Error en proceso de generación de credenciales del sistema",
  com_sinpepay_label_system_generate_credencials_option: "Credenciales",

  /** device */
  com_sinpepay_label_system_device_add_title: "Agregar dispositivo",
  com_sinpepay_label_system_device_update_title: "Editar dispositivo",
  com_sinpepay_label_system_device_rootmenu_title: "Menú interno",
  com_sinpepay_label_system_device_rootmenu_title2: "Interno",
  com_sinpepay_label_system_device_find_error: "Error en consulta de dispositivos",
  com_sinpepay_label_system_device_findid_error: "Error en consulta por id del dispositivo",
  com_sinpepay_label_system_device_save_error: "Error en proceso de guardar el dispositivo",
  com_sinpepay_label_system_device_update_error: "Error en proceso de actualizar el dispositivo",
  com_sinpepay_label_system_device_inactive_error: "Error en proceso de inactivar el dispositivo",
  com_sinpepay_label_system_device_active_error: "Error en proceso de activar el dispositivo",

  /** terminal */
  com_sinpepay_label_system_device_terminal_add_title: "Agregar terminal",

  /** userdevice*/
  com_sinpepay_label_system_userdevice_add_title: "Agregar usuario por dispositivo",
  com_sinpepay_label_system_userdevice_update_title: "Editar usuario por dispositivo",
  com_sinpepay_label_system_userdevice_find_error: "Error en consulta de usuarios por dispositivos",
  com_sinpepay_label_system_userdevice_findid_error: "Error en consulta por id del usuario por dispositivos",
  com_sinpepay_label_system_userdevice_save_error: "Error en proceso de guardar el usuario por dispositivos",
  com_sinpepay_label_system_userdevice_update_error: "Error en proceso de actualizar el usuario por dispositivos",
  com_sinpepay_label_system_userdevice_inactive_error: "Error en proceso de inactivar el usuario por dispositivos",
  com_sinpepay_label_system_userdevice_active_error: "Error en proceso de activar el usuario por dispositivos",



  /** servicetype */
  com_sinpepay_label_servicetype_add_title: "Agregar tipo de servicio",
  com_sinpepay_label_servicetype_update_title: "Editar tipo de servicio",

  com_sinpepay_label_servicetype_find_error: "Error en consulta de tipo de servicios por organización",
  com_sinpepay_label_servicetype_findid_error: "Error en consulta por id del sistema",
  com_sinpepay_label_servicetype_save_error: "Error en proceso de guardar tipo de servicio",
  com_sinpepay_label_servicetype_update_error: "Error en proceso de actualizar tipo de servicio",
  com_sinpepay_label_servicetype_inactive_error: "Error en proceso de inactivar tipo de servicio",
  com_sinpepay_label_servicetype_active_error: "Error en proceso de activar tipo de servicio",


  /** phone */
  com_sinpepay_label_phone_add_title: "Agregar teléfono",
  com_sinpepay_label_phone_update_title: "Editar teléfono",

  com_sinpepay_label_phone_find_error: "Error en consulta de telefonos por organización",
  com_sinpepay_label_phone_findid_error: "Error en consulta por id del teléfono",
  com_sinpepay_label_phone_save_error: "Error en proceso de guardar teléfono",
  com_sinpepay_label_phone_update_error: "Error en proceso de actualizar teléfono",
  com_sinpepay_label_phone_active_error: "Error en proceso de activar teléfono",
  com_sinpepay_label_phone_inactive_error: "Error en proceso de inactivar teléfono",
  com_sinpepay_label_phone_main_phone: "Ya cuenta con un teléfono principal asignado.",
  com_sinpepay_label_phone_not_main_phone: "Debe existir minimo un teléfono principal",
  com_sinpepay_label_phone_code_main_phone: "SC0035",
  com_sinpepay_label_phone_code_not_main_phone: "SC0036",
  com_sinpepay_label_phone_code_duplicate_phone: "SC0039",

  com_sinpepay_label_security_phone_create_unique_code_tittle: "Crear código único",
  com_sinpepay_label_modal_phone_create_unique_code_body: (phone) => `¿Está seguro de crear el código único al teléfono ${phone} ?`,
  com_sinpepay_label_security_phone_create_unique_code_error: "Error en proceso de crear el código único",
  com_sinpepay_label_request_phone_create_unique_code: "Se creó el código único de forma exitosa",


  /** phoneservice */
  com_sinpepay_label_phoneservice_add_title: "Agregar teléfono por servicio",
  com_sinpepay_label_phoneservice_update_title: "Editar teléfono por servicio",

  com_sinpepay_label_phoneservice_find_error: "Error en consulta de telefonos por tipo de servicio",
  com_sinpepay_label_phoneservice_findid_error: "Error en consulta por id del teléfono por tipo de servicio",
  com_sinpepay_label_phoneservice_save_error: "Error en proceso de guardar teléfono por tipo de servicio",
  com_sinpepay_label_phoneservice_update_error: "Error en proceso de actualizar teléfono por tipo de servicio",
  com_sinpepay_label_phoneservice_active_error: "Error en proceso de activar teléfono por tipo de servicio",
  com_sinpepay_label_phoneservice_inactive_error: "Error en proceso de inactivar teléfono por tipo de servicio",

  /** affiliate */
  com_sinpepay_label_affiliate_add_title: "Agregar afiliado",
  com_sinpepay_label_affiliate_update_title: "Editar afiliado",

  com_sinpepay_label_affiliate_find_error: "Error en consulta de afiliados por organización",
  com_sinpepay_label_affiliate_findid_error: "Error en consulta por id del afiliado",
  com_sinpepay_label_affiliate_save_error: "Error en proceso de guardar afiliado",
  com_sinpepay_label_affiliate_update_error: "Error en proceso de actualizar afiliado",
  com_sinpepay_label_affiliate_inactive_error: "Error en proceso de inactivar afiliado",
  com_sinpepay_label_affiliate_active_error: "Error en proceso de activar afiliado",

  com_sinpepay_label_affiliate_add_confirm: "Confirmar registro",

  /** termianl */
  com_sinpepay_label_affiliate_terminal_add_title: "Agregar terminal",
  com_sinpepay_label_affiliate_terminal_update_title: "Editar terminal",
  com_sinpepay_label_affiliate_terminal_rootmenu_title: "Menú interno",
  com_sinpepay_label_affiliate_terminal_rootmenu_title2: "Interno",
  com_sinpepay_label_affiliate_terminal_find_error: "Error en consulta de terminales",
  com_sinpepay_label_affiliate_terminal_findid_error: "Error en consulta por id del terminal",
  com_sinpepay_label_affiliate_terminal_save_error: "Error en proceso de guardar el terminal",
  com_sinpepay_label_affiliate_terminal_update_error: "Error en proceso de actualizar el terminal",
  com_sinpepay_label_affiliate_terminal_inactive_error: "Error en proceso de inactivar el terminal",
  com_sinpepay_label_affiliate_terminal_active_error: "Error en proceso de activar el terminal",
  com_sinpepay_label_affiliate_terminal_add_device_error: "Error en proceso de asociar la terminal",
  com_sinpepay_label_affiliate_terminal_del_device_error: "Error en proceso de desasociar la terminal",
  com_sinpepay_label_affiliate_terminal_add_device_success: "Terminal agregada correctamente",
  com_sinpepay_label_affiliate_terminal_del_device_success: "Terminal liberada correctamente",


  /** plan */
  com_sinpepay_label_plan_add_title: "Agregar plan",
  com_sinpepay_label_plan_update_title: "Editar plan",
  com_sinpepay_label_plan_rootmenu_title: "Menú interno",
  com_sinpepay_label_plan_rootmenu_title2: "Interno",
  com_sinpepay_label_plan_find_error: "Error en consulta de planes",
  com_sinpepay_label_plan_findid_error: "Error en consulta por id del plan",
  com_sinpepay_label_plan_save_error: "Error en proceso de guardar el plan",
  com_sinpepay_label_plan_update_error: "Error en proceso de actualizar el plan",
  com_sinpepay_label_plan_inactive_error: "Error en proceso de inactivar el plan",
  com_sinpepay_label_plan_active_error: "Error en proceso de activar el plan",

  /** search transaction */
  com_sinpepay_label_search_transaction_view_title: "Detalle de transacción",
  com_sinpepay_label_search_preregister_view_title: "Detalle de preregistro",

  com_sinpepay_label_search_transaction_startdate_validation_error: "Fecha desde mayor a fecha hasta",
  com_sinpepay_label_search_transaction_enddate_validation_error: "El rango de fechas debe ser máximo un mes",
  com_sinpepay_label_search_transaction_error: "Error en consulta de transacción",

  /** conciliation */
  com_sinpepay_label_search_transaction_button_conciliation_title: "Conciliar",
  com_sinpepay_label_conciliation_single_error: "Error en proceso de conciliar la transacción",
  com_sinpepay_label_modal_single_conciliation_title: "Conciliar transacción",
  com_sinpepay_label_modal_single_conciliation_body: "¿Está seguro de conciliar esta transacción?",
  com_sinpepay_label_modal_single_conciliation_success_body: "Se realizó la concilición de la transacción correctamente.",
  com_sinpepay_label_modal_single_conciliation_fail_body: "No se realizó la concilición de la transacción.",
  com_sinpepay_label_modal_multi_conciliation_title: "Conciliar transacciones",
  com_sinpepay_label_modal_multi_conciliation_body: (num) =>
    `¿Está seguro de conciliar las ${num} transacciones seleccionadas?`,
  com_sinpepay_label_modal_multi_conciliation_success1_body: (num) =>
    `Numero de transacciones por conciliar enviadas ${num}: `,
  com_sinpepay_label_modal_multi_conciliation_success2_body: (num) =>
    `Conciliadas: ${num}`,
  com_sinpepay_label_modal_multi_conciliation_success3_body: (num) =>
    `No Conciliadas: ${num}`,
  com_sinpepay_label_search_transaction_massive_select_title: "Seleccionadar todos",
  com_sinpepay_label_search_transaction_massive_deselect_title: "Desmarcar todos",
  com_sinpepay_label_search_transaction_conciliation_massive_title: "Conciliar seleccionadas",

  /** request parameter */
  com_sinpepay_label_generalconfig_accordion_title: "General",
  com_sinpepay_label_requestparameter_accordion_title: "Parámetros de solicitud (Conciliación)",
  com_sinpepay_label_requestparameter_add_title: "Agregar Parámetro de solicitud",
  com_sinpepay_label_requestparameter_update_title: "Editar Parámetro de solicitud",
  com_sinpepay_label_requestparameter_secretindicator: "Secreto (KeyVault)",
  com_sinpepay_label_requestparameter_bodyindicator: "Parámetro del cuerpo de la solicitud",

  com_sinpepay_label_requestparameter_find_error: "Error en consulta de parámetros de solicitud por organización",
  com_sinpepay_label_requestparameter_findid_error: "Error en consulta por id del parámetro de solicitud",
  com_sinpepay_label_requestparameter_save_error: "Error en proceso de guardar el parámetro de solicitud",
  com_sinpepay_label_requestparameter_update_error: "Error en proceso de actualizar el parámetro de solicitud",
  com_sinpepay_label_requestparameter_inactive_error: "Error en proceso de inactivar el parámetro de solicitud",
  com_sinpepay_label_requestparameter_active_error: "Error en proceso de activar el parámetro de solicitud",

  /** segment */
  com_sinpepay_label_segment_add_title: "Agregar Segmento",
  com_sinpepay_label_segment_update_title: "Editar Segmento",
  com_sinpepay_label_segment_rootmenu_title: "Menú interno",
  com_sinpepay_label_segment_rootmenu_title2: "Interno",
  com_sinpepay_label_segment_find_error: "Error en consulta de Segmentos",
  com_sinpepay_label_segment_findid_error: "Error en consulta por id del Segmento",
  com_sinpepay_label_segment_save_error: "Error en proceso de guardar el Segmento",
  com_sinpepay_label_segment_update_error: "Error en proceso de actualizar el Segmento",
  com_sinpepay_label_segment_inactive_error: "Error en proceso de inactivar el Segmento",
  com_sinpepay_label_segment_active_error: "Error en proceso de activar el Segmento",

  /** Commission */
  com_sinpepay_label_commission_accordion_title: "Comisiones",
  com_sinpepay_label_commission_type: "Tipo de comisión",
  com_sinpepay_label_commission_segment_type: "Segmento",
  com_sinpepay_label_commission_type_daily: "Diaria",
  com_sinpepay_label_commission_type_monthly: "Mensual",
  com_sinpepay_label_commission_type_minimum_billing_monthly: "Mensual Facturación Mínima",
  com_sinpepay_label_not_commission: "Sin comisión",

  // Preautorizacion
  com_sinpepay_label_preauthorized_indicator: "Activar preautorización",

  // Reembolosos
  com_sinpepay_label_refund_accordion_title: "Reembolsos",
  com_sinpepay_label_refund_indicator: "¿Posee reembolso?",
  com_sinpepay_label_refund_max_attempts: "Límite máximo de intentos para procesar un reembolso",
  com_sinpepay_label_refund_request_time: "Tiempo máximo para solicitar reembolso (días)",
  com_sinpepay_label_refund_max_per_request: "Límite máximo de reembolsos exitosos por cada transacción",
  com_sinpepay_label_refund_field_format: (num) =>
    `El valor debe ser igual o menor a ${num}.`,

  // type identification
  com_sinpepay_label_select: "Seleccione opción",
  com_sinpepay_label_national_id: "Cédula Nacional",
  com_sinpepay_label_dimex: "DIMEX",
  com_sinpepay_label_legal_certificate: "Cédula Jurídica",
  com_sinpepay_label_passport: "Pasaporte",
  com_sinpepay_label_didi: "DIDI",
  com_sinpepay_label_government: "Gobierno",
  com_type_identification: " Tipo de identificación",

  // Preregister verify
  com_sinpepay_label_search_preregister_button_verify_title: "Validar pago",
  com_sinpepay_label_modal_verify_title: "Validar pago del preregistro",
  com_sinpepay_label_modal_verify_body: "¿Está seguro de validar el pago de este preregistro?",
  com_sinpepay_label_modal_verify_success_body: "Se realizó la validación del preregistro correctamente.",
  com_sinpepay_label_verify_error: "Error en proceso de validar preregistro",

  // preauthorizedAmounts
  com_sinpepay_label_preauthorizedamounts_save_error: "Error en proceso de guardar el monto pre.autorizado",
  com_sinpepay_label_preauthorizedamounts_update_error: "Error en proceso de actualizar el monto pre.autorizado",
  com_sinpepay_label_preauthorizedamounts_inactive_error: "Error en proceso de inactivar el monto pre.autorizado",
  com_sinpepay_label_preauthorizedamounts_active_error: "Error en proceso de activar el monto pre.autorizado",
  com_sinpepay_label_dashboard_menu_maintenance_preauthorizedamounts: "Montos Pre.Autorizados",
  com_sinpepay_label_preauthorizedamounts_add_title: "Agregar Montos Pre.Autorizados",
  com_sinpepay_label_preauthorizedamounts_update_title: "Editar Montos Pre.Autorizados",
  com_sinpepay_label_dashboard_preauthorizedamount: "Monto Pre.Autorizado"
};